import { useEffect, useState } from "react";

import PageHead from "../Head";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import CategoryHead from "@/components/Category/CategoryHead";
import Pagination from "@/components/Common/Pagination";
import FooterOne from "@/components/Footer/Footer-One";

// import CourseDetails from "../../data/course-details/courseData.json";
import BackToTop from "../backToTop";
import CourseTab from "@/components/Category/Filter/CourseTab";
import CourseSidebar from "@/components/Category/Filter/CourseSidebar";
import CPStaticContent from '../../models/CPStaticContent.js'
import Instagram from "@/components/Instagram/Instagram";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";
import CourseCardThree from "@/components/Category/Filter/CourseCard-Three";

const CourseWithSidebarLayout = (post) => {
  const ITEMS_PER_PAGE = 15

  const [courses, setCourse] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  // let getAllCourse = JSON.parse(
  //   JSON.stringify(CourseDetails.courseDetails.slice(0, 12))
  // );
  let getAllCourse = post.list

  const startIndex = (page - 1) * ITEMS_PER_PAGE;
  // const getSelectedCourse = courses.slice(startIndex, startIndex + ITEMS_PER_PAGE);
  const getSelectedCourse = getAllCourse.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const handleClick = (num) => {
    setPage(num);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    setCourse(getAllCourse);
    setTotalPages(Math.ceil(getAllCourse.length / ITEMS_PER_PAGE));
  }, [setTotalPages, setCourse]);

  return (
    <>
      <PageHead title="Certifications" description="Collection of certifications prepared by CloudPedia.AI" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType={true} />
          <MobileMenu />
          <Cart />

          <CategoryHead category={getAllCourse} title={"All Certifications"} countLabel="Certifications" desc="Certifications collected by CloudPedia.AI" />
          <div className="rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <div className="row row--30 gy-5">
                <div className="col-lg-3 order-2 order-lg-1">
                  <CourseSidebar courses={getAllCourse} />
                </div>
                {/* <div className="col-lg-9 order-1 order-lg-2">
                  <CourseTab course={getSelectedCourse} />
                </div> */}
                <div className="col-lg-9 order-1 order-lg-2">
                  <CourseCardThree course={getSelectedCourse} type="certification" />
                </div>
              </div>

              {getAllCourse.length > ITEMS_PER_PAGE ? (
                <div className="row">
                  <div className="col-lg-12 mt--60">
                    <Pagination
                      totalPages={totalPages}
                      pageNumber={page}
                      handleClick={handleClick}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>

          <Instagram />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default CourseWithSidebarLayout;

export async function getStaticProps(context) {
  const stContent = new CPStaticContent("certification")
  await stContent.fetchContent()
  return await stContent.getListProps()
} 